import { render, staticRenderFns } from "./PayoutsTable.vue?vue&type=template&id=1496882f&scoped=true"
import script from "./PayoutsTable.vue?vue&type=script&lang=js"
export * from "./PayoutsTable.vue?vue&type=script&lang=js"
import style0 from "./PayoutsTable.vue?vue&type=style&index=0&id=1496882f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1496882f",
  null
  
)

export default component.exports